webpackJsonp([1],{

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


// Production
// Firebase.initializeApp({
//   apiKey: 'AIzaSyCQzCt70IkPMqWpbOeq_bIJB0UXcY9PxVw',
//   authDomain: 'nonprofiterscom.firebaseapp.com',
//   databaseURL: 'https://nonprofiterscom.firebaseio.com',
//   projectId: 'nonprofiterscom',
//   storageBucket: '',
//   messagingSenderId: '164156801326'
// })

// Staging
__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp({
  apiKey: 'AIzaSyA9uxzzBkiPVHr8tLWX77YbSmAGiYS_iYs',
  authDomain: 'nonprofiters-staging.firebaseapp.com',
  databaseURL: 'https://nonprofiters-staging.firebaseio.com',
  projectId: 'nonprofiters-staging',
  storageBucket: 'nonprofiters-staging.appspot.com',
  messagingSenderId: '512606812580'
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_firebase___default.a);

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

module.exports = [{"value":"emergency","label":"Emergency"},{"value":"clothing","label":"Clothing"},{"value":"counseling-mediation","label":"Counseling & Mediation"},{"value":"employment","label":"Employment"},{"value":"dental","label":"Dental"},{"value":"domestic","label":"Domestic Violence & Sexual Abuse"},{"value":"financial-assistance","label":"Financial Assistance"},{"value":"food-boxes","label":"Food Boxes"},{"value":"healthcare","label":"Healthcare"},{"value":"hivaids","label":"HIV/AIDS"},{"value":"legal-services","label":"Legal Services"},{"value":"lgbt","label":"GLBTQI"},{"value":"meals","label":"Meals"},{"value":"personal-care","label":"Personal Care"},{"value":"pet-care","label":"Pet Care"},{"value":"renters-services","label":"Renters Services"},{"value":"recovery","label":"Addiction Recovery"},{"value":"shelter","label":"Shelter"},{"value":"transitional-housing","label":"Transitional Housing"},{"value":"utility-assistance","label":"Utility Assistance"},{"value":"youth-services","label":"Youth Services"},{"value":"veteran-services","label":"Veteran Services"}]

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Turns a phone string into a tel: link
   * @param  {STR} phone The phone number
   * @return {STR}       The linked phone number, or null
   */
  phoneLinkify: function phoneLinkify(phone) {
    // Turn ext into a , which is used as the ext part in tel:
    var link = phone.replace(/ext/ig, ',');
    // Strip all other non numbers and comma
    link = link.replace(/[^0-9,]/g, '');
    // leave the last comma
    link = link.replace(/[,](?=.*[,])/g, '');

    return link ? 'tel:' + link : null;
  }
});

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intake_vue__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1695ddc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Intake_vue__ = __webpack_require__(548);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intake_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1695ddc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Intake_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 241:
/***/ (function(module, exports) {

module.exports = {"intakeConfig":{"housing":null,"referral":null,"sex":null,"family":null,"ssi":null,"senior":null}}

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f67e1bf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(558);
function injectStyle (ssrContext) {
  __webpack_require__(553)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f67e1bf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Listing_vue__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70100c40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Listing_vue__ = __webpack_require__(568);
function injectStyle (ssrContext) {
  __webpack_require__(566)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Listing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70100c40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Listing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EventBus__ = __webpack_require__(600);






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__webpack_require__(602), {
  prevent: ['input', 'textarea']
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__webpack_require__(603));

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype, {
  $bus: {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_4__EventBus__["a" /* default */];
    }
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<router-view></router-view>'
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Main__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layouts_Embed__ = __webpack_require__(571);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__layouts_Main__["a" /* default */]
  }, {
    path: '/start',
    component: __WEBPACK_IMPORTED_MODULE_2__layouts_Main__["a" /* default */],
    props: {
      preloadIntakeModal: true
    }
  }, {
    path: '/checklist',
    component: __WEBPACK_IMPORTED_MODULE_2__layouts_Main__["a" /* default */],
    props: {
      viewChecklist: true
    }
  }, {
    path: '/embed',
    component: __WEBPACK_IMPORTED_MODULE_3__layouts_Embed__["a" /* default */]
  }]
}));

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273798f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(570);
function injectStyle (ssrContext) {
  __webpack_require__(268)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273798f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 268:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modal_Login__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modal_Profile__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_Resource__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_About__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_Intake__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_IntakeConfig__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_map_Main__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_map_Key__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_checklist_Overview__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_resource_Listing__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lockr__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lockr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lockr__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














// @TODO Remove this migration script entirely once we have a backup of the migrated database somewhere safe, preferrably in another firestore instance
// import V1Migrations from '@/components/admin/V1Migrations'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'layout-main',

  components: {
    ModalAbout: __WEBPACK_IMPORTED_MODULE_3__components_modal_About__["a" /* default */],
    ModalResource: __WEBPACK_IMPORTED_MODULE_2__components_modal_Resource__["a" /* default */],
    ModalIntake: __WEBPACK_IMPORTED_MODULE_4__components_modal_Intake__["a" /* default */],
    ModalLogin: __WEBPACK_IMPORTED_MODULE_0__components_modal_Login__["a" /* default */],
    ModalProfile: __WEBPACK_IMPORTED_MODULE_1__components_modal_Profile__["a" /* default */],
    ModalIntakeConfig: __WEBPACK_IMPORTED_MODULE_5__components_modal_IntakeConfig__["a" /* default */],
    MapMain: __WEBPACK_IMPORTED_MODULE_6__components_map_Main__["a" /* default */],
    MapKey: __WEBPACK_IMPORTED_MODULE_7__components_map_Key__["a" /* default */],
    ResourceListing: __WEBPACK_IMPORTED_MODULE_9__components_resource_Listing__["a" /* default */],
    ChecklistOverview: __WEBPACK_IMPORTED_MODULE_8__components_checklist_Overview__["a" /* default */]
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapState */])(['isMainSidebarActive', 'isAboutModalActive', 'isLoginModalActive', 'isProfileModalActive', 'isIntakeModalActive', 'isIntakeConfigModalActive', 'isResourceModalActive', 'view', 'user', 'resources', 'checklist']),

  props: ['preloadIntakeModal', 'viewChecklist'],

  data: function data() {
    return {
      isDragging: false,
      dragStartY: 0,
      initMapHeight: __WEBPACK_IMPORTED_MODULE_11_lockr___default.a.get('initMapHeight') || '250px'
    };
  },
  created: function created() {
    // Route: /start
    if (this.preloadIntakeModal) this.$store.commit('toggleIntakeModal');
    // Route: /checklist
    else if (this.viewChecklist) this.$store.commit('viewChecklist');
      // Route: /
      else this.$store.commit('viewMain');

    this.$store.commit('filterResources');
  },
  mounted: function mounted() {
    var _this = this;

    // Handle Resizers
    this.$refs.header.$el.style.height = this.initMapHeight;

    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    this.$refs.key.$el.addEventListener('mousedown', this.startKeyResize);
    this.$el.addEventListener('mouseup', this.stopKeyResize);
    this.$refs.key.$el.addEventListener('touchstart', this.startTouchKeyResize);
    this.$el.addEventListener('touchend', this.stopKeyResize);
    this.$refs.main.addEventListener('mousemove', this.maybeDoKeyResize);
    this.$refs.main.addEventListener('touchmove', this.maybeDoTouchKeyResize);

    // Just in case
    // @TODO figure out why calling it once above doesn't work (my guess is that I should user innerHeight or something)
    setTimeout(function () {
      return _this.handleResize();
    }, 1000);
    setTimeout(function () {
      return _this.handleResize();
    }, 3000);
  },


  watch: {
    $route: function $route(to, from) {
      var _this2 = this;

      if (to.path === '/' && this.isIntakeModalActive || to.path === '/start' && !this.isIntakeModalActive) this.$store.commit('toggleIntakeModal');else if (to.path === '/checklist') this.$store.commit('viewChecklist');else if (to.path === '/') this.$store.commit('viewMain');

      this.$store.commit('filterResources');
      this.$nextTick(function () {
        return _this2.handleResize();
      });
    }
  },

  methods: {
    toggleSidebar: function toggleSidebar() {
      this.$store.commit('toggleMainSidebar');
    },
    toggleLogin: function toggleLogin() {
      this.$store.commit('toggleLoginModal');
    },
    toggleProfile: function toggleProfile() {
      this.$store.commit('toggleProfileModal');
    },
    toggleResourceModal: function toggleResourceModal(resource) {
      this.$store.commit('toggleResourceModal', resource);
    },
    toggleAbout: function toggleAbout() {
      this.$store.commit('toggleAboutModal');
    },
    toggleIntakeModal: function toggleIntakeModal() {
      this.$store.commit('toggleIntakeModal');
      if (!this.checklist) {
        this.$router.push('/start');
      }
    },
    gotoChecklist: function gotoChecklist() {
      this.$router.push('/checklist');
    },
    gotoMain: function gotoMain() {
      var _this3 = this;

      this.$refs.btnViewAllResources.classList.add('loading');
      setTimeout(function () {
        _this3.$router.push('/');
      }, 100);
    },
    logout: function logout() {
      this.$store.commit('logout');
    },
    closeModals: function closeModals() {
      this.$store.commit('closeModals');
      this.$router.push('/');
    },


    /**
     * Handles the panel sizes
     */
    handleResize: function handleResize() {
      var $main = this.$refs.main;
      var $header = this.$refs.header.$el;
      var $key = this.$refs.key.$el;
      var $footer = this.$refs.footer;

      var mainHeight = $main.clientHeight;
      var headerHeight = $header.clientHeight;
      var keyHeight = this.view !== 'main' ? 0 : $key.clientHeight;
      var footerHeight = mainHeight - headerHeight - keyHeight;

      $header.style.height = headerHeight + 'px';
      $footer.style.height = footerHeight + 'px';
    },


    /**
     * Resize the panes via key drag
     */
    startKeyResize: function startKeyResize(ev) {
      this.dragStartY = ev.offsetY;
      this.isDragging = true;
    },
    startTouchKeyResize: function startTouchKeyResize(ev) {
      var touch = ev.changedTouches[0];
      touch.offsetY = touch.screenY - this.$refs.key.$el.offsetTop - 10 - this.$refs.header.$el.offsetTop;
      this.startKeyResize(touch);
    },
    maybeDoKeyResize: function maybeDoKeyResize(ev) {
      if (this.isDragging) {
        var $header = this.$refs.header.$el;
        var $key = this.$refs.key.$el;

        $header.style.height = this.initMapHeight = ev.screenY - this.dragStartY - $key.clientHeight - $header.offsetTop - 10 + 'px';
        this.handleResize();
      }
    },
    maybeDoTouchKeyResize: function maybeDoTouchKeyResize(ev) {
      this.maybeDoKeyResize(ev.changedTouches[0]);
    },
    stopKeyResize: function stopKeyResize() {
      __WEBPACK_IMPORTED_MODULE_11_lockr___default.a.set('initMapHeight', this.initMapHeight);
      window.google.maps.event.trigger(this.$refs.header.$refs.map.$mapObject, 'resize');
      this.isDragging = false;
    }
  }
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03eb4668_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(352);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03eb4668_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_firebase__ = __webpack_require__(105);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-login',

  data: function data() {
    return {
      isLoading: false
    };
  },


  methods: {
    closeModal: function closeModal() {
      this.$store.commit('toggleLoginModal');
    },
    twitterLogin: function twitterLogin() {
      var _this = this;

      var provider = new __WEBPACK_IMPORTED_MODULE_0__service_firebase__["a" /* default */].auth.TwitterAuthProvider();
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__service_firebase__["a" /* default */].auth().signInWithPopup(provider)
      // @TODO Let's add a welcome message if result.additionalUserInfo.isNewUser
      // @TODO We should make stay connected opt-in: https://firebase.google.com/docs/auth/web/auth-state-persistence
      .then(function (result) {
        _this.$store.commit('setUser', result.user);
      })
      // @TODO Let's toast the error message (test by turning off connection or temp disabling authorized domains)
      .catch(function (err) {
        console.error(err);
      }).then(function () {
        _this.isLoading = false;
        _this.$store.commit('toggleLoginModal');
      });
    }
  }
});

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal active"},[_c('div',{staticClass:"modal-overlay",on:{"click":_vm.closeModal}}),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"btn btn-clear float-right",on:{"click":_vm.closeModal}}),_c('div',{staticClass:"modal-title h5"},[_vm._v("Sign In / Register")])]),_vm._m(0),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",class:{loading: _vm.isLoading},on:{"click":_vm.twitterLogin}},[_vm._v("Twitter Sign In")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"content"},[_c('blockquote',{staticClass:"message warning"},[_c('b',[_vm._v("We're in beta!")]),_vm._v(" Thanks for checking us out! This part of the site is currently under heavy development, and logging in won't let you do too much yet. Please follow us on Twitter "),_c('a',{attrs:{"href":"https://twitter.com/nonprofiters"}},[_vm._v("@Nonprofiters")]),_vm._v(" or "),_c('a',{attrs:{"href":"https://twitter.com/heyozramos"}},[_vm._v("@HeyOzRamos")]),_vm._v(" to keep tabs on this feature. Thanks!")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eff364a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(355);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eff364a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-profile',

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])(['checklist']),

  data: function data() {
    return {
      isLoading: false
    };
  },


  methods: {
    closeModal: function closeModal() {
      this.$store.commit('toggleProfileModal');
    },
    deleteAccount: function deleteAccount() {
      this.$store.commit('deleteUser');
    },
    toggleIntakeModal: function toggleIntakeModal() {
      this.$store.commit('toggleIntakeModal');
      if (this.isIntakeModalActive) {
        this.$router.push('/start');
      }
    }
  }
});

/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal active"},[_c('div',{staticClass:"modal-overlay",on:{"click":_vm.closeModal}}),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"btn btn-clear float-right",on:{"click":_vm.closeModal}}),_c('div',{staticClass:"modal-title h5"},[_vm._v("Profile")])]),_c('div',{staticClass:"modal-body"},[_vm._m(0),(_vm.checklist)?_c('div',{staticClass:"panel-footer",on:{"click":_vm.toggleIntakeModal}},[_c('button',{staticClass:"btn"},[_vm._v("Edit Intake Answers")])]):_vm._e()]),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-error",class:{loading: _vm.isLoading},on:{"click":_vm.deleteAccount}},[_vm._v("Delete Account")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',{staticClass:"info"},[_vm._v("To change your account information, please update it on "),_c('a',{attrs:{"href":"https://twitter.com/settings/account"}},[_vm._v("Twitter")]),_vm._v(" and reload this page.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resource_vue__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fd268d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Resource_vue__ = __webpack_require__(535);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resource_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fd268d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Resource_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lockr__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lockr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lockr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_categories__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_categories___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__mixins_categories__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__webpack_require__(93);

var panoService = void 0;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__, {
  load: {
    key: 'AIzaSyD3BUYczjmcnPnJlFCtOKkvH4Y7f_9168Q',
    libraries: 'places'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-resource',

  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a
  },

  // We compute the following because this modal is used for both adding and editing
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
    editingResource: 'editingResource',
    intakeConfig: 'intakeConfig',

    modalTitle: function modalTitle() {
      return this.editingResource ? 'Edit' : 'Add';
    },
    saveLabel: function saveLabel() {
      return this.editingResource ? 'Save Changes' : 'Add Resource';
    }
  }),

  created: function created() {
    panoService = new window.google.maps.StreetViewService();
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
      var categories = [];

      // Transforms data for use with special input fields
      if (_this.editingResource) {
        // Set the intake form data
        _this.$store.commit('setIntakeConfig', _this.editingResource.intakeConfig);

        // Transform Google Place Search
        _this.$el.querySelector('#modal\\/Resource\\:place').value = _this.editingResource.formattedAddress;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.$data, _this.editingResource);

        // Transform vue-multiselect requires the entire {label,value} to compare, which we do here
        _this.editingResource.categories.forEach(function (category) {
          _this.ignoredData.categories.some(function (compare) {
            var found = false;
            if (compare.value === category) {
              categories.push(compare);
              found = true;
            }
            return found;
          });
        });

        _this.categories = categories;
      } else {
        _this.$store.commit('clearIntakeConfig');
      }

      // Select the first field and clear out validator (since the focus action may trigger a validation)
      _this.$refs.autofocus.focus();
      window.google.maps.event.trigger(_this.$refs.map.$panoObject, 'resize');
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
        return _this.$validator.reset();
      });
    });
  },


  watch: {
    ignoredData: {
      handler: function handler(data) {
        return __WEBPACK_IMPORTED_MODULE_8_lockr___default.a.set('resource-showExtraFields', data.extraFields);
      },
      deep: true
    },

    // The pano is "rendered" but css-hidden. This causes render issues when it's finally shown as there were no dimensions.
    // This triggers a refresh
    placeID: function placeID() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
        return window.google.maps.event.trigger(_this2.$refs.map.$panoObject, 'resize');
      });
    },


    // Remember the first of the last categories for faster data entry
    categories: function categories(data) {
      __WEBPACK_IMPORTED_MODULE_8_lockr___default.a.set('resource-lastCategory', [data[0]]);
    }
  },

  data: function data() {
    var lastCategory = __WEBPACK_IMPORTED_MODULE_8_lockr___default.a.get('resource-lastCategory');

    return {
      title: '',
      notes: '',
      categories: lastCategory || [],
      lat: 0,
      lng: 0,

      // A direct link to addresses Google Maps page, for direction purposes
      mapURL: '',
      placeID: '',
      website: '',
      phone: '',
      phoneLink: '',

      // The address as shown in the input field
      formattedAddress: '',
      pov: null,
      pano: null,

      ignoredData: {
        isLoading: false,
        extraFields: __WEBPACK_IMPORTED_MODULE_8_lockr___default.a.get('resource-showExtraFields') || false,

        /**
         * To add new categories, simply add a new {key, tooltip}.
         * - Add a corresponding `/static/img/map/${key}.png` marker image.
         * - For markers, @see https://mapicons.mapsmarker.com/
         * @type {Array}
         */
        categories: __WEBPACK_IMPORTED_MODULE_9__mixins_categories___default.a
      }
    };
  },


  methods: {
    closeModal: function closeModal() {
      this.$store.commit('toggleResourceModal');
    },


    // Break up the Google Place Search data into its components
    setPlace: function setPlace(place) {
      var _this3 = this;

      this.pano = null;
      this.lat = place.geometry.location.lat();
      this.lng = place.geometry.location.lng();
      this.formattedAddress = place.formatted_address;
      this.mapURL = place.url;
      this.placeID = place.place_id;

      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
        return _this3.setPano();
      });
    },
    setPOV: function setPOV(pov) {
      this.pov = pov;
    },
    setPano: function setPano(pano) {
      var _this4 = this;

      if (pano) {
        this.pano = pano;
      } else {
        // This service is required to get only outdoor street views
        // @see https://stackoverflow.com/questions/32256936/disable-indoor-view-of-buildings-in-google-maps-street-view
        panoService.getPanorama({
          location: { lat: this.lat, lng: this.lng },
          radius: 1000,
          source: window.google.maps.StreetViewSource.OUTDOOR
        }, function (data, status) {
          if (status === window.google.maps.StreetViewStatus.OK) {
            _this4.$refs.map.$panoObject.setPano(data.location.pano);
          }
        });
      }
    },


    // @TODO We should (dis|en)able the submit button live
    submit: function submit() {
      var _this5 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var db = __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.firestore();
          var ref = void 0;
          var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["omit"])(_this5.$data, ['ignoredData']), {
            savedBy: _this5.$store.state.user.uid,
            savedOn: __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.database.ServerValue.TIMESTAMP
          });

          var _categories = [];
          data.categories.forEach(function (item) {
            return _categories.push(item.value);
          });
          data.categories = _categories;
          data.phoneLink = __WEBPACK_IMPORTED_MODULE_4__util__["a" /* default */].phoneLinkify(data.phone);
          data.key = data.key || db.collection('resource').doc();
          data.intakeConfig = _this5.intakeConfig;

          // If we're editing then the key is known (a string), if not, then the key IS the ref
          if (typeof data.key === 'string') {
            ref = db.collection('resource').doc(data.key);
          } else {
            ref = data.key;
            data.key = ref.id;
          }
          ref.set(data, { merge: true });
          _this5.$store.commit('toggleResourceModal');
        }
      });
    },
    openIntakeConfig: function openIntakeConfig() {
      this.$store.commit('toggleIntakeConfigModal');
    }
  }
});

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d1e9e4ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(478);
var normalizeComponent = __webpack_require__(4)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d1e9e4ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a49fa3a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(482);
function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var normalizeComponent = __webpack_require__(4)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a49fa3a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 480:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0d473226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(486);
function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var normalizeComponent = __webpack_require__(4)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0d473226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 484:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4c86d54a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(489);
var normalizeComponent = __webpack_require__(4)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4c86d54a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7d2989da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(495);
var normalizeComponent = __webpack_require__(4)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7d2989da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal active",class:{"modal-lg": _vm.ignoredData.extraFields}},[_c('div',{staticClass:"modal-overlay",on:{"click":_vm.closeModal}}),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"btn btn-clear float-right",on:{"click":_vm.closeModal}}),_c('div',{staticClass:"modal-title h5"},[_vm._v(_vm._s(_vm.modalTitle)+" Resource")])]),_c('div',{staticClass:"modal-body"},[_c('form',{staticClass:"content form-horizontal"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"},{name:"validate",rawName:"v-validate",value:("required"),expression:"\"required\""}],ref:"autofocus",staticClass:"form-input",attrs:{"id":"modal/Resource:title","type":"text","placeholder":"Resource Title"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_c('div',{staticClass:"form-input-error-message"},[_vm._v("A title is required")])])]),_c('div',{staticClass:"form-group"},[_vm._m(1),_c('div',{staticClass:"col-9"},[_c('multiselect',{directives:[{name:"validate",rawName:"v-validate",value:("required"),expression:"\"required\""}],attrs:{"options":_vm.ignoredData.categories,"label":"label","track-by":"value","multiple":true,"close-on-select":false,"placeholder":"Select Categories"},model:{value:(_vm.categories),callback:function ($$v) {_vm.categories=$$v},expression:"categories"}}),_c('div',{staticClass:"form-input-error-message"},[_vm._v("A category is required")])],1)]),_c('div',{staticClass:"form-group"},[_vm._m(2),_c('div',{staticClass:"col-9"},[_c('gmap-autocomplete',{ref:"address",staticClass:"form-input",attrs:{"id":"modal/Resource:place","placeholder":"Resource Address"},on:{"place_changed":_vm.setPlace}})],1)]),_c('div',{staticClass:"form-group",class:{hidden: !_vm.ignoredData.extraFields || !_vm.placeID}},[_vm._m(3),_c('div',{staticClass:"col-9"},[_c('gmap-street-view-panorama',{ref:"map",staticStyle:{"height":"300px"},attrs:{"position":{lat: _vm.lat, lng: _vm.lng},"pov":_vm.pov,"pano":_vm.pano},on:{"pov_changed":_vm.setPOV,"pano_changed":_vm.setPano}})],1)]),(_vm.ignoredData.extraFields)?_c('div',{staticClass:"form-group"},[_vm._m(4),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website),expression:"website"}],staticClass:"form-input",attrs:{"id":"modal/Resource:website","type":"text","placeholder":"Website"},domProps:{"value":(_vm.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website=$event.target.value}}})])]):_vm._e(),(_vm.ignoredData.extraFields)?_c('div',{staticClass:"form-group"},[_vm._m(5),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"form-input",attrs:{"id":"modal/Resource:phone","type":"text","placeholder":"Phone Number"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})])]):_vm._e(),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"form-label",attrs:{"for":"modal/Resource:notes"}},[_vm._v("Notes")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notes),expression:"notes"}],staticClass:"form-input",attrs:{"id":"modal/Resource:notes","placeholder":"Resource Notes (location details, hours, restrictions, etc)","rows":"5"},domProps:{"value":(_vm.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notes=$event.target.value}}})])])])]),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn float-left",on:{"click":_vm.openIntakeConfig}},[_vm._v("Intake Config")]),_c('span',{staticClass:"form-group"},[_c('label',{staticClass:"form-switch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ignoredData.extraFields),expression:"ignoredData.extraFields"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.ignoredData.extraFields)?_vm._i(_vm.ignoredData.extraFields,null)>-1:(_vm.ignoredData.extraFields)},on:{"change":function($event){var $$a=_vm.ignoredData.extraFields,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ignoredData.extraFields=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ignoredData.extraFields=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.ignoredData, "extraFields", $$c)}}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Show Extra Fields")])]),_c('button',{staticClass:"btn btn-primary",class:{loading: _vm.ignoredData.isLoading},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.saveLabel))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('label',{staticClass:"form-label",attrs:{"for":"modal/Resource:title"}},[_vm._v("Title")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('label',{staticClass:"form-label",attrs:{"for":"modal/Resource:categories"}},[_vm._v("Categories")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('label',{staticClass:"form-label",attrs:{"for":"modal/Resource:place"}},[_vm._v("Address")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('label',[_vm._v("Set Street View")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('label',{staticClass:"form-label",attrs:{"for":"modal/Resource:website"}},[_vm._v("Website")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('label',{staticClass:"form-label",attrs:{"for":"modal/Resource:phone"}},[_vm._v("Phone")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef76332_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(538);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef76332_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-about',

  methods: {
    closeModal: function closeModal() {
      this.$store.commit('toggleAboutModal');
    }
  }
});

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal active"},[_c('div',{staticClass:"modal-overlay",on:{"click":_vm.closeModal}}),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"btn btn-clear float-right",on:{"click":_vm.closeModal}}),_c('div',{staticClass:"modal-title h5"},[_vm._v("About")])]),_vm._m(0),_c('div',{staticClass:"modal-footer"},[_c('a',{staticClass:"btn float-left",attrs:{"href":"https://nonprofiters.com/api/getResources","target":"_blank"}},[_vm._v("Download Database")]),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.closeModal}},[_vm._v("Close")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"content"},[_c('p',[_c('strong',[_vm._v("Nonprofiters is a digital case worker for the homeless and low income communities")]),_vm._v(".")]),_c('p',[_vm._v("Case workers can get people out of homelessness and help low-income individuals thrive. However, case workers are often overwhelmed with clients causing people to be placed on long waitlists (sometimes as long as a year or more).")]),_c('p',[_vm._v("Nonprofiters helps these individuals in the meantime by offering guidance on how to navigate the massive nonprofit landscape.")]),_c('p',[_vm._v("The shorterm goal is to eventually develop the site into a social network, allowing community members to assist each other. Our longterm goal is to help end homelessness completely in the US by 2050, and globally by 2100.")]),_c('p',[_vm._v("Our vision is a world where the basic requirements to live and innovate are completely free for everyone, everywhere.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intake_vue__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6540b053_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Intake_vue__ = __webpack_require__(549);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intake_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6540b053_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Intake_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_checklist_Intake__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lockr__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lockr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lockr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__webpack_require__(93);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-intake',

  components: {
    IntakeForm: __WEBPACK_IMPORTED_MODULE_4__components_checklist_Intake__["a" /* default */]
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['user', 'checklist', 'intakeConfig', 'intakeData']),

  data: function data() {
    return {
      currentStep: 0,

      // Determines whether to go back to the main route or just close the modal
      isInitialIntake: true,

      step: [{ title: 'Intake: Overview' }, { title: 'Intake: Form' }]
    };
  },
  mounted: function mounted() {
    this.$store.commit('setIntakeConfig', this.intakeData);

    // Skips immediately to the form if the user has filled it out
    this.currentStep = +__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.intakeData).some(function (data) {
      return !!data;
    });

    if (this.checklist && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.checklist).length) {
      this.isInitialIntake = false;
    } else {
      this.isInitialIntake = true;
    }
  },


  methods: {
    closeModal: function closeModal() {
      this.$store.commit('toggleIntakeModal');
      if (this.isInitialIntake) this.$router.push('/');
    },
    nextStep: function nextStep() {
      this.currentStep = Math.min(this.step.length - 1, this.currentStep + 1);
    },
    prevStep: function prevStep() {
      this.currentStep = Math.max(0, this.currentStep - 1);
    },


    // Saves the checklist in localstorage and additionally in firestore if logged in
    createChecklist: function createChecklist() {
      var data = {
        intake: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.intakeConfig)

        // Only save if the user is logged in
      };if (this.user.uid) {
        var db = __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.firestore();
        data.updatedOn = __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database.ServerValue.TIMESTAMP;
        data.user = this.user.uid;
        db.collection('checklist').doc(this.user.uid).set(data, { merge: true });
      }

      __WEBPACK_IMPORTED_MODULE_5_lockr___default.a.set('intakeData', this.intakeConfig);
      this.$store.commit('setChecklist', data);
      this.closeModal();
    }
  }
});

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'intake-form',

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])(['intakeConfig'])
});

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Are you currently homeless?")]),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.housing),expression:"intakeConfig.housing"}],attrs:{"type":"radio","value":"address"},domProps:{"checked":_vm._q(_vm.intakeConfig.housing,"address")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "housing", "address")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("No")]),_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.housing),expression:"intakeConfig.housing"}],attrs:{"type":"radio","value":"homeless"},domProps:{"checked":_vm._q(_vm.intakeConfig.housing,"homeless")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "housing", "homeless")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Yes")])]),_c('p',[_vm._v("Do you currently have a case worker?")]),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.referral),expression:"intakeConfig.referral"}],attrs:{"type":"radio","value":"null-caseworker"},domProps:{"checked":_vm._q(_vm.intakeConfig.referral,"null-caseworker")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "referral", "null-caseworker")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("No")]),_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.referral),expression:"intakeConfig.referral"}],attrs:{"type":"radio","value":"referral"},domProps:{"checked":_vm._q(_vm.intakeConfig.referral,"referral")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "referral", "referral")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Yes")])]),_c('p',[_vm._v("What do you most strongly identify as?")]),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.sex),expression:"intakeConfig.sex"}],attrs:{"type":"radio","value":"male"},domProps:{"checked":_vm._q(_vm.intakeConfig.sex,"male")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "sex", "male")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Male")]),_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.sex),expression:"intakeConfig.sex"}],attrs:{"type":"radio","value":"female"},domProps:{"checked":_vm._q(_vm.intakeConfig.sex,"female")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "sex", "female")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Female")]),_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.sex),expression:"intakeConfig.sex"}],attrs:{"type":"radio","value":"sex-other"},domProps:{"checked":_vm._q(_vm.intakeConfig.sex,"sex-other")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "sex", "sex-other")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Other")])]),_c('p',[_vm._v("Are you a legal guardian?")]),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.family),expression:"intakeConfig.family"}],attrs:{"type":"radio","value":"null-family"},domProps:{"checked":_vm._q(_vm.intakeConfig.family,"null-family")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "family", "null-family")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("No")]),_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.family),expression:"intakeConfig.family"}],attrs:{"type":"radio","value":"family"},domProps:{"checked":_vm._q(_vm.intakeConfig.family,"family")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "family", "family")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Yes")])]),_c('p',[_vm._v("Do you currently receive SSI, SSDI or VA Pension?")]),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.ssi),expression:"intakeConfig.ssi"}],attrs:{"type":"radio","value":"null-ssi"},domProps:{"checked":_vm._q(_vm.intakeConfig.ssi,"null-ssi")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "ssi", "null-ssi")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("No")]),_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.ssi),expression:"intakeConfig.ssi"}],attrs:{"type":"radio","value":"ssi"},domProps:{"checked":_vm._q(_vm.intakeConfig.ssi,"ssi")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "ssi", "ssi")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Yes")])]),_c('p',[_vm._v("Are you disabled?")]),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.disabled),expression:"intakeConfig.disabled"}],attrs:{"type":"radio","value":"null-disabled"},domProps:{"checked":_vm._q(_vm.intakeConfig.disabled,"null-disabled")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "disabled", "null-disabled")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("No")]),_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.disabled),expression:"intakeConfig.disabled"}],attrs:{"type":"radio","value":"disabled"},domProps:{"checked":_vm._q(_vm.intakeConfig.disabled,"disabled")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "disabled", "disabled")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Yes")])]),_c('p',[_vm._v("Do you have mental health concerns?")]),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.mental-_vm.health),expression:"intakeConfig.mental-health"}],attrs:{"type":"radio","value":"null-mental-health"},domProps:{"checked":_vm._q(_vm.intakeConfig.mental-_vm.health,"null-mental-health")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "mental-health", "null-mental-health")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("No")]),_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.mental-_vm.health),expression:"intakeConfig.mental-health"}],attrs:{"type":"radio","value":"mental-health"},domProps:{"checked":_vm._q(_vm.intakeConfig.mental-_vm.health,"mental-health")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "mental-health", "mental-health")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Yes")])]),_c('p',[_vm._v("Are you a minority?")]),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.minority),expression:"intakeConfig.minority"}],attrs:{"type":"radio","value":"null-minority"},domProps:{"checked":_vm._q(_vm.intakeConfig.minority,"null-minority")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "minority", "null-minority")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("No")]),_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.minority),expression:"intakeConfig.minority"}],attrs:{"type":"radio","value":"minority"},domProps:{"checked":_vm._q(_vm.intakeConfig.minority,"minority")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "minority", "minority")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Yes")])]),_c('p',[_vm._v("Are you a veteran?")]),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.veteran),expression:"intakeConfig.veteran"}],attrs:{"type":"radio","value":"null-veteran"},domProps:{"checked":_vm._q(_vm.intakeConfig.veteran,"null-veteran")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "veteran", "null-veteran")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("No")]),_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.veteran),expression:"intakeConfig.veteran"}],attrs:{"type":"radio","value":"veteran"},domProps:{"checked":_vm._q(_vm.intakeConfig.veteran,"veteran")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "veteran", "veteran")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Yes")])]),_c('p',[_vm._v("Are you a senior?")]),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.senior),expression:"intakeConfig.senior"}],attrs:{"type":"radio","value":"null-senior"},domProps:{"checked":_vm._q(_vm.intakeConfig.senior,"null-senior")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "senior", "null-senior")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("No")]),_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.senior),expression:"intakeConfig.senior"}],attrs:{"type":"radio","value":"senior"},domProps:{"checked":_vm._q(_vm.intakeConfig.senior,"senior")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "senior", "senior")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Yes")])]),_c('p',[_vm._v("Are you under 21?")]),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.youth),expression:"intakeConfig.youth"}],attrs:{"type":"radio","value":"null-youth"},domProps:{"checked":_vm._q(_vm.intakeConfig.youth,"null-youth")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "youth", "null-youth")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("No")]),_c('label',{staticClass:"form-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.intakeConfig.youth),expression:"intakeConfig.youth"}],attrs:{"type":"radio","value":"youth"},domProps:{"checked":_vm._q(_vm.intakeConfig.youth,"youth")},on:{"change":function($event){_vm.$set(_vm.intakeConfig, "youth", "youth")}}}),_c('i',{staticClass:"form-icon"}),_vm._v("Yes")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal active"},[_c('div',{staticClass:"modal-overlay",on:{"click":_vm.closeModal}}),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"btn btn-clear float-right",on:{"click":_vm.closeModal}}),_c('div',{staticClass:"modal-title h5"},[_vm._v(_vm._s(_vm.step[_vm.currentStep].title))])]),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"content"},[(_vm.currentStep === 0)?_c('div',[_vm._m(0),_vm._m(1),_c('p',[_vm._v("This form will help connect you to the resources you need. The more questions you answer the more directly we can help. You may update your responses at any time.")]),_c('p',[_vm._v("At the end, you will be given a step-by-step checklist of things to do that will improve your quality of life immediately!")])]):_vm._e(),(_vm.currentStep === 1)?_c('div',[_c('intake-form')],1):_vm._e()])]),_c('div',{staticClass:"modal-footer"},[(_vm.currentStep > 0)?_c('button',{staticClass:"btn btn-link float-left",on:{"click":_vm.prevStep}},[_vm._v("Back")]):_vm._e(),(_vm.currentStep < _vm.step.length - 1)?_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.nextStep}},[_vm._v("Next")]):_vm._e(),(_vm.currentStep === _vm.step.length - 1)?_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.createChecklist}},[_vm._v("Save Form")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',{staticClass:"message warning"},[_c('b',[_vm._v("We're in beta!")]),_vm._v(" Thanks for checking us out! This part of the site is currently under heavy development. Please follow us on Twitter "),_c('a',{attrs:{"href":"https://twitter.com/nonprofiters"}},[_vm._v("@Nonprofiters")]),_vm._v(" or "),_c('a',{attrs:{"href":"https://twitter.com/heyozramos"}},[_vm._v("@HeyOzRamos")]),_vm._v(" to keep tabs on this feature. Thanks!")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',{staticClass:"message info"},[_c('b',[_vm._v("Did you know?")]),_vm._v(" Portland, OR is home to over 200 active organizations that can help you get anything you might need to live a more meaningful life. Right now. For free.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntakeConfig_vue__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2538ff3b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_IntakeConfig_vue__ = __webpack_require__(552);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntakeConfig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2538ff3b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_IntakeConfig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_checklist_Intake__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_init__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_init___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__store_init__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-intake-config',

  components: {
    IntakeForm: __WEBPACK_IMPORTED_MODULE_1__components_checklist_Intake__["a" /* default */]
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['intakeConfig']),

  mounted: function mounted() {
    this.initIntakeConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.intakeConfig);
  },
  data: function data() {
    return {
      initIntakeConfig: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_3__store_init___default.a.intakeConfig)
    };
  },


  methods: {
    closeModal: function closeModal() {
      this.$store.commit('toggleIntakeConfigModal');
    },


    // Resets the intake form to what it was when we loaded it
    cancel: function cancel() {
      this.$store.commit('setIntakeConfig', this.initIntakeConfig);
      this.closeModal();
    },
    clearConfig: function clearConfig() {
      this.$store.commit('clearIntakeConfig');
    }
  }
});

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal active"},[_c('div',{staticClass:"modal-overlay"}),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"btn btn-clear float-right",on:{"click":_vm.cancel}}),_c('div',{staticClass:"modal-title h5"},[_vm._v("Intake Form")])]),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"content"},[_vm._m(0),_c('intake-form')],1)]),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn float-left",on:{"click":_vm.clearConfig}},[_vm._v("Clear Config")]),_c('button',{staticClass:"btn btn-link",on:{"click":_vm.cancel}},[_vm._v("Cancel")]),_c('button',{staticClass:"btn btn-primary ml-1",on:{"click":_vm.closeModal}},[_vm._v("Save Config")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',{staticClass:"message info"},[_c('b',[_vm._v("About this form:")]),_vm._v(" The resource you are editing will be shown to anyone who generates a checklist matching any of the following criteria.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themes_ultra_light_json__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themes_ultra_light_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__themes_ultra_light_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__, {
  load: {
    key: 'AIzaSyD3BUYczjmcnPnJlFCtOKkvH4Y7f_9168Q',
    libraries: 'places'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'map-main',

  props: ['embedded'],

  created: function created() {
    this.$bus.$on('focusMarker', this.centerMap);
    this.$bus.$on('toggleStreetView', this.toggleStreetView);
    this.$store.commit('filterResources');

    if (this.$props.embedded) {
      this.$store.commit('showAllCategories');
    }
  },


  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['activeCategories', 'isLoadingResources', 'hasActiveMarkers', 'visibleResources']),

  mounted: function mounted() {
    var _this = this;

    var query = __WEBPACK_IMPORTED_MODULE_5_qs___default.a.parse(location.search, { ignoreQueryPrefix: true }) || {};

    // Toggle categories based on the querystring
    if (query.cat) {
      this.$store.commit('hideAllCategories');
      this.$store.commit('toggleCategories', query.cat.split(','));
    }

    // Update map query strings
    this.$refs.map.$mapCreated.then(function () {
      _this.$refs.map.$mapObject.addListener('dragend', _this.rememberMapPosition);
      _this.$refs.map.$mapObject.addListener('zoom_changed', _this.rememberMapPosition);
    });
  },
  data: function data() {
    // Set the query defaults
    var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
      lat: 45.5231,
      lng: -122.6765,
      zoom: 15
    }, __WEBPACK_IMPORTED_MODULE_5_qs___default.a.parse(location.search, { ignoreQueryPrefix: true }));
    query.lat = parseFloat(query.lat);
    query.lng = parseFloat(query.lng);
    query.zoom = parseInt(query.zoom);

    return {
      /**
       * Initializes the Google Map instance with *any* standard setting,
       * even those not documented in vue-google-maps
       *
       * For options: @see https://developers.google.com/maps/documentation/javascript/tutorial#MapOptions
       *
       * For styles: @see https://snazzymaps.com/
       * - Copy/Paste the file into:
       *    /src/components/map/themes/${filename}.json
       *  , include it and pass it here under the `styles` key
       */
      options: {
        styles: __WEBPACK_IMPORTED_MODULE_4__themes_ultra_light_json___default.a
      },

      // The maps center
      center: {
        lat: query.lat,
        lng: query.lng
      },

      // The maps zoom
      zoom: query.zoom,

      info: {
        options: {
          // These are part of the vue-google-maps and actually represent left, top
          pixelOffset: {
            width: 0,
            height: -35
          }
        },

        // The markers lat/lng
        position: {
          lat: 0,
          lng: 0
        },

        // The street view's panorama ID
        pano: null,

        // The street view's POV pitch, rotation
        pov: null,

        isOpened: false,

        content: {
          title: '',
          address: '',
          notes: ''
        },

        // The key representing the corresponding marker,
        // which itself represents the Firestore ref ID within the streets collection
        key: null
      }
    };
  },


  methods: {
    /**
     * Shows the infotip over the marker with `key`
     *
     * @param  {OBJ} resource  The resource firestore object
     * @param  {STR} key       The resource key (ref)
     * @param  {BOL} forceShow Whether to force show (true) or to toggle based on this.info.isOpened.
     *                         If true, also scrolls the listing view to the matching listing with `key`
     */
    showInfo: function showInfo(resource, key, forceShow) {
      this.info.position = {
        lat: resource.lat,
        lng: resource.lng,
        pano: resource.pano,
        pov: resource.pov

        // Compares w/ current resource key to toggle on/off...
      };if (this.info.key === key && !forceShow) {
        this.info.isOpened = !this.info.isOpened;

        // ...vs showing at resource position
      } else {
        this.info.isOpened = true;
        this.info.key = key;
        this.info.content = {
          title: resource.title,
          address: resource.formattedAddress,
          mapURL: resource.mapURL,
          notes: resource.notes,
          website: resource.website
        };
      }

      // If we're not forceShowing, then also scroll to the resource listing
      if (!forceShow) {
        this.$bus.$emit('focusListing', resource);
      }
    },
    toggleStreetView: function toggleStreetView(position) {
      var pano = this.$refs.map.$mapObject.getStreetView();
      pano.setPano(position.pano);
      pano.setPov(position.pov);
      pano.setVisible(true);
    },
    centerMap: function centerMap(resource) {
      var pano = this.$refs.map.$mapObject.getStreetView();
      pano.setVisible(false);

      this.showInfo(resource, resource.placeID, true);
      this.$refs.map.$mapObject.setCenter({
        lat: resource.lat,
        lng: resource.lng
      });
    },


    /**
     * Updates the querystring with the maps position for persistence
     */
    rememberMapPosition: function rememberMapPosition() {
      var $map = this.$refs.map.$mapObject;
      var query = __WEBPACK_IMPORTED_MODULE_5_qs___default.a.parse(location.search, { ignoreQueryPrefix: true }) || {};

      query.zoom = $map.getZoom();
      query.lat = $map.getCenter().lat();
      query.lng = $map.getCenter().lng();

      this.$router.replace({ query: query });
    }
  }
});

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

module.exports = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]

/***/ }),

/***/ 558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-map"}},[_c('div',{staticClass:"map-wrap"},[(!_vm.hasActiveMarkers && !_vm.isLoadingResources)?_c('div',{staticClass:"overlay-wrap"},[_vm._m(0)]):_vm._e(),(!_vm.hasActiveMarkers && _vm.isLoadingResources)?_c('div',{staticClass:"overlay-wrap"},[_vm._m(1)]):_vm._e(),_c('gmap-map',{ref:"map",attrs:{"zoom":_vm.zoom,"center":_vm.center,"options":_vm.options}},[_c('gmap-info-window',{attrs:{"options":_vm.info.options,"position":_vm.info.position,"opened":_vm.info.isOpened},on:{"closeclick":function($event){_vm.info.isOpened = false}}},[(_vm.info.content.title)?_c('p',[_c('strong',[_vm._v(_vm._s(_vm.info.content.title))]),_c('a',{on:{"click":function($event){_vm.toggleStreetView(_vm.info.position)}}},[_vm._v(" (Toggle Street View)")])]):_vm._e(),(_vm.info.content.mapURL)?_c('p',[_c('a',{attrs:{"href":_vm.info.content.mapURL}},[_vm._v(_vm._s(_vm.info.content.address))])]):_vm._e(),(_vm.info.content.website)?_c('p',[_c('a',{attrs:{"href":_vm.info.content.website}},[_vm._v(_vm._s(_vm.info.content.website))])]):_vm._e(),(_vm.info.content.notes)?_c('pre',[_vm._v(_vm._s(_vm.info.content.notes))]):_vm._e()]),_vm._l((_vm.visibleResources),function(resource,key){return (resource.lat || resource.lng)?_c('gmap-marker',{key:key,attrs:{"icon":resource.icon,"position":{lat: resource.lat, lng: resource.lng}},on:{"click":function($event){_vm.showInfo(resource, key)}}}):_vm._e()})],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('h1',[_vm._v("No resources found")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('h1',[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Key_vue__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf3031e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Key_vue__ = __webpack_require__(562);
function injectStyle (ssrContext) {
  __webpack_require__(560)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Key_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf3031e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Key_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 560:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_categories__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_categories___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mixins_categories__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'map-key',

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])(['activeCategories', 'isLoadingResources']),

  data: function data() {
    return {
      /**
       * To add new categories, simply add a new {key, tooltip}.
       * - Add a corresponding `/static/img/map/${key}.png` marker image.
       * - For markers, @see https://mapicons.mapsmarker.com/
       * @type {Array}
       */
      categories: __WEBPACK_IMPORTED_MODULE_1__mixins_categories___default.a
    };
  },


  methods: {
    toggleCategory: function toggleCategory(category) {
      var activeCategories = [];
      var query = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.parse(location.search, { ignoreQueryPrefix: true }) || {};

      this.$store.commit('toggleCategories', [category]);
      this.$store.commit('filterResources');

      // Extract only the active categories
      for (var cat in this.activeCategories) {
        if (!this.activeCategories[cat]) {
          activeCategories.push(cat);
        }
      }

      query.cat = activeCategories.join(',');
      this.$router.replace({ query: query });
    }
  }
});

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"key-container"}},_vm._l((_vm.categories),function(category){return _c('span',{staticClass:"map-key-item",class:{active: !_vm.activeCategories[category.value]},on:{"click":function($event){_vm.toggleCategory(category.value)}}},[_c('img',{staticClass:"tooltip",attrs:{"src":'/static/img/map/' + category.value + '.png',"title":category.label}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f64b11c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__(569);
function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f64b11c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_resource_Listing__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checklist-overview',

  components: {
    ResourceListing: __WEBPACK_IMPORTED_MODULE_0__components_resource_Listing__["a" /* default */]
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['checklist'])
});

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'resource-listing',

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])(['activeCategories', 'hasActiveMarkers', 'isLoadingResources', 'visibleResources', 'user', 'view', 'checklist']),

  created: function created() {
    this.$bus.$on('focusListing', this.focusListing);
  },


  watch: {
    // Force an update when the route changes
    view: function view() {
      this.$forceUpdate();
    }
  },

  methods: {
    showOnMap: function showOnMap(resource) {
      this.$bus.$emit('focusMarker', resource);
    },
    showStreetView: function showStreetView(resource) {
      this.$bus.$emit('toggleStreetView', {
        lat: resource.lat,
        lng: resource.lng,
        pano: resource.pano,
        pov: resource.pov
      });
    },
    focusListing: function focusListing(resource) {
      var $listing = this.$root.$children[0].$refs.resourceListing.$el.querySelector('#listing-' + resource.placeID);
      if ($listing) {
        this.$root.$children[0].$refs.footer.scrollTop = $listing.offsetTop - this.$el.offsetTop;
      }
    },
    editResource: function editResource(resource) {
      this.$store.commit('toggleResourceModal', resource);
    }
  }
});

/***/ }),

/***/ 568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"listview"}},[(!_vm.hasActiveMarkers && !_vm.isLoadingResources)?_c('div',{staticClass:"empty"},[_c('p',{staticClass:"empty-title h5"},[_vm._v("No resources found")]),_c('p',{staticClass:"empty-subtitle"},[_vm._v("Try activating some categories")])]):_vm._e(),(!_vm.hasActiveMarkers && _vm.isLoadingResources)?_c('div',{staticClass:"empty"},[_c('p',{staticClass:"empty-title h5"},[_vm._v("Loading...")])]):_vm._e(),_c('div',{staticClass:"columns"},_vm._l((_vm.visibleResources),function(resource,key){return _c('div',{ref:"listing",refInFor:true,staticClass:"resource-listing column col-4 col-xl-6 col-md-12",attrs:{"id":"listing-" + resource.placeID}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('img',{staticClass:"category-icon",attrs:{"src":resource.icon}}),_c('span',[_vm._v(_vm._s(resource.title))]),(resource.phone)?_c('div',[_c('small',[_c('a',{attrs:{"href":resource.phoneLink}},[_vm._v(_vm._s(resource.phone))])])]):_vm._e(),(resource.mapURL)?_c('div',[_c('small',[_c('a',{attrs:{"href":resource.mapURL}},[_vm._v(_vm._s(resource.formattedAddress))])])]):_vm._e(),(resource.website)?_c('div',[_c('small',[_c('a',{attrs:{"href":resource.website}},[_vm._v(_vm._s(resource.website))])])]):_vm._e()]),(resource.notes)?_c('div',{staticClass:"card-body"},[_c('pre',[_vm._v(_vm._s(resource.notes))])]):_vm._e(),_c('div',{staticClass:"card-footer"},[_c('p',{staticClass:"btn-group btn-group-block"},[(resource.lng || resource.lat)?_c('button',{staticClass:"btn btn-link",on:{"click":function($event){_vm.showStreetView(resource)}}},[_vm._v("Show street view")]):_vm._e(),(resource.lng || resource.lat)?_c('button',{staticClass:"btn",on:{"click":function($event){_vm.showOnMap(resource)}}},[_vm._v("Show on map")]):_vm._e()]),(_vm.user.uid && _vm.view !== "checklist")?_c('div',{staticClass:"btn-group btn-group-block"},[_c('button',{staticClass:"btn",on:{"click":function($event){_vm.editResource(resource)}}},[_vm._v("Edit")])]):_vm._e()])])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column col-6 col-md-12",attrs:{"id":"overview-column"}},[_c('h2',[_vm._v("Checklist")]),(_vm.checklist.intake.housing === "homeless")?_c('div',{staticClass:"card"},[_vm._m(0),_vm._m(1)]):_vm._e(),(_vm.checklist.intake.referral !== "referral")?_c('div',{staticClass:"card"},[_vm._m(2),_vm._m(3)]):_vm._e(),(_vm.checklist.intake.sex === "other")?_c('div',{staticClass:"card"},[_vm._m(4),_vm._m(5)]):_vm._e()]),_c('div',{staticClass:"column col-6 col-md-12"},[_c('h2',{staticStyle:{"margin-bottom":"5px"}},[_vm._v("Resources")]),_c('resource-listing')],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-title h5"},[_vm._v("Housing")]),_c('div',{staticClass:"card-subtitle text-gray"},[_c('strong',[_vm._v("Estimated timeline:")]),_vm._v(" < 1 year")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('ol',[_c('li',[_vm._v("Find temporary shelter")]),_c('li',[_vm._v("Get a TB card (See Transition Projects)")]),_c('li',[_vm._v("Get into a transitional housing program")]),_c('li',[_vm._v("If you have poor rental history, sign up for RentWell")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-title h5"},[_vm._v("Referral")]),_c('div',{staticClass:"card-subtitle text-gray"},[_c('strong',[_vm._v("Estimated timeline:")]),_vm._v(" < 1 month")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('p',[_vm._v("Nonprofiters will help you get started, but a real case manager will help you finish. A case manager will help you write checks and provide referrals for things you may need.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-title h5"},[_vm._v("GLBTQI Advocate")]),_c('div',{staticClass:"card-subtitle text-gray"},[_vm._v("Estimated timeline: < 1 week")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('p',[_vm._v("A GLBTQI advocate can help you gain access")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"off-canvas",attrs:{"id":"app","data-view":_vm.view}},[_c('header',{directives:[{name:"shortkey",rawName:"v-shortkey.once",value:(["esc"]),expression:"[\"esc\"]",modifiers:{"once":true}}],staticClass:"navbar",on:{"shortkey":function($event){_vm.closeModals()}}},[_vm._m(0),_c('div',{staticClass:"navbar-section"},[_c('div',{staticClass:"off-canvas-toggle btn btn-link btn-action",on:{"click":_vm.toggleSidebar}},[_c('div',{staticClass:"icon icon-menu"})])])]),_c('div',{staticClass:"off-canvas-sidebar",class:{active: _vm.isMainSidebarActive},staticStyle:{"box-shadow":"0 0 3px rgba(0,0,0,0.35)"}},[_vm._m(1),(_vm.user.uid)?_c('div',{staticClass:"sidebar-section text-center"},[_c('p'),_c('figure',{staticClass:"avatar avatar-xl"},[_c('img',{attrs:{"src":_vm.user.providerData[0].photoURL.replace("_normal", "_bigger"),"alt":_vm.user.displayName}})]),_c('p'),_c('p',[_vm._v(_vm._s(_vm.user.displayName))])]):_vm._e(),_c('div',{staticClass:"sidebar-section"},[(_vm.user.uid)?_c('p',{staticClass:"btn-group btn-group-block"},[_c('button',{staticClass:"btn",on:{"click":_vm.logout}},[_vm._v("Logout")]),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.toggleProfile}},[_vm._v("Settings")])]):_vm._e(),(!_vm.user.uid)?_c('p',{staticClass:"btn-group btn-group-block"},[_c('button',{staticClass:"btn",on:{"click":_vm.toggleLogin}},[_vm._v("Sign In")])]):_vm._e()]),_c('div',{staticClass:"sidebar-section"},[_c('p',{staticClass:"btn-group btn-group-block"},[(_vm.checklist && _vm.view === "main")?_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.gotoChecklist}},[_vm._v("View Checklist")]):_vm._e(),(_vm.checklist && _vm.view === "checklist")?_c('button',{ref:"btnViewAllResources",staticClass:"btn",on:{"click":_vm.gotoMain}},[_vm._v("View All Resources")]):_vm._e(),(!_vm.checklist)?_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.toggleIntakeModal}},[_vm._v("Start Here!")]):_vm._e()]),(!_vm.user.uid && _vm.checklist)?_c('p',{staticClass:"btn-group btn-group-block"},[_c('button',{staticClass:"btn btn-group-block",on:{"click":_vm.toggleIntakeModal}},[_vm._v("Edit Intake Answers")])]):_vm._e()]),_c('div',{staticClass:"sidebar-section"},[_c('ul',[_c('li',[_c('a',{on:{"click":_vm.toggleAbout}},[_vm._v("About")])])])]),(_vm.user.uid && _vm.view === "main")?_c('div',{staticClass:"sidebar-section"},[_c('p',{staticClass:"btn-group btn-group-block"},[_c('button',{directives:[{name:"shortkey",rawName:"v-shortkey.once",value:(["a"]),expression:"[\"a\"]",modifiers:{"once":true}}],staticClass:"btn",on:{"click":function($event){_vm.toggleResourceModal()},"shortkey":function($event){_vm.toggleResourceModal()}}},[_vm._v("Add Resource")])])]):_vm._e()]),_c('div',{staticClass:"off-canvas-overlay",on:{"click":_vm.toggleSidebar}}),_c('main',{ref:"main",staticClass:"off-canvas-content"},[_c('div',{attrs:{"id":"main"}},[_c('map-main',{ref:"header",staticStyle:{"height":"200px"}}),_c('map-key',{ref:"key",class:{hidden: _vm.view !== "main"}}),_c('div',{ref:"footer",attrs:{"id":"main-footer"}},[(_vm.view !== "checklist")?_c('resource-listing',{ref:"resourceListing"}):_c('checklist-overview')],1)],1)]),(!_vm.user.uid && _vm.isLoginModalActive)?_c('modal-login'):_vm._e(),(_vm.user.uid && _vm.isProfileModalActive)?_c('modal-profile'):_vm._e(),(_vm.user.uid && _vm.isResourceModalActive)?_c('modal-resource'):_vm._e(),(_vm.isIntakeModalActive)?_c('modal-intake'):_vm._e(),(_vm.isAboutModalActive)?_c('modal-about'):_vm._e(),(_vm.isIntakeConfigModalActive)?_c('modal-intake-config'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-section"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo mr-3",staticStyle:{"margin-left":"10px"},attrs:{"src":"static/img/favicon.png"}}),_vm._v("Nonprofiters")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-section text-center"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":"static/img/favicon.png"}}),_vm._v("Nonprofiters")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Embed_vue__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29377bbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Embed_vue__ = __webpack_require__(574);
function injectStyle (ssrContext) {
  __webpack_require__(572)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Embed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29377bbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Embed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 572:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_map_Main__ = __webpack_require__(242);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'layout-embed',

  components: {
    MapMain: __WEBPACK_IMPORTED_MODULE_0__components_map_Main__["a" /* default */]
  }
});

/***/ }),

/***/ 574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('map-main',{attrs:{"embedded":"embedded"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);



/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Filters by categories
   *
   * @param  {OBJ} resources  List of resources
   * @param  {OBJ} categories List of categories a resource must contain to be visible
   *
   * @return {OBJ} {visible, hidden} List of filtered resources
   */
  byCategory: function byCategory(resources, categories) {
    var filtered = {
      visible: {},
      hidden: {},
      hasActiveMarkers: false
    };

    for (var key in resources) {
      var resource = resources[key];
      var contains = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(resource.categories).some(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            index = _ref2[0],
            key = _ref2[1];

        return !categories[key];
      });
      var filter = contains ? 'visible' : 'hidden';
      filtered[filter][key] = resource;
      if (contains) filtered.hasActiveMarkers = true;
    }

    return filtered;
  },


  /**
   * Normalizes an intake config by removing empty answers or answers starting with 'null-'
   *
   * @param  {OBJ} config The intake answer set
   * @return {OBJ}        The noarmalized answer set
   */
  normalizeIntakeConfig: function normalizeIntakeConfig(config) {
    var answers = {};
    for (var key in config) {
      if (config[key] && !config[key].includes('null-')) answers[key] = config[key];
    }
    return answers;
  },


  /**
   * Filters by the intake checklist
   *
   * @param  {OBJ} resources List of resources
   * @param  {OBJ} checklist The intake checklist
   *
   * @return {OBJ} {visible, hidden} List of filtered resources
   */
  byChecklist: function byChecklist(resources, checklist) {
    var _this = this;

    var filtered = {
      visible: {},
      hidden: {},
      hasActiveMarkers: false
    };
    var intake = this.normalizeIntakeConfig(checklist.intake);

    var _loop = function _loop(key) {
      var resource = resources[key];
      var requirements = _this.normalizeIntakeConfig(resource.intakeConfig);

      // Automatically toss if there are no requirements
      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(requirements).length) {
        filtered.hidden[key] = resource;
        return 'continue';
      }

      // Check if at least some of the requirements are met
      var matched = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(requirements).some(function (question) {
        filtered.hidden[key] = resource;
        return intake[question] && intake[question] === requirements[question];
      });

      // Automatically remove if sex does not match
      if (requirements.sex && intake.sex && requirements.sex !== intake.sex) matched = false;

      // Automatically remove if case work does not match
      if (requirements.referral && intake.referral && requirements.referral !== intake.referral) matched = false;

      if (matched) {
        filtered.visible[key] = resource;
        filtered.hasActiveMarkers = true;
      } else {
        filtered.hidden[key] = resource;
      }
    };

    for (var key in resources) {
      var _ret = _loop(key);

      if (_ret === 'continue') continue;
    }

    return filtered;
  }
});

/***/ }),

/***/ 597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_firebase__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(99);



/**
 * Handle Firebase immediately as it requires an additional httpRequest
 */
__WEBPACK_IMPORTED_MODULE_0__service_firebase__["a" /* default */].auth().onAuthStateChanged(function (user) {
  // @TODO Add a logout message
  if (user) {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setUser', user);
  } else {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setUser', {});
    localStorage.clear();
  }
});

/***/ }),

/***/ 598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(200);




__webpack_require__(93);
var db = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();

db.collection('resource').onSnapshot(function (snap) {
  var resources = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.resources);

  snap.docChanges.forEach(function (change) {
    var data = change.doc.data();

    switch (change.type) {
      case 'removed':
        if (resources[data.key]) delete resources[data.key];
        break;

      default:
        var categories = data.categories;
        var index = Math.floor(Math.random() * categories.length);

        data.icon = 'static/img/map/' + categories[index] + '.png';
        // @TODO do this on save and migrate so that we don't need to do this here!
        data.phoneLink = __WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */].phoneLinkify(data.phone);

        resources[data.key] = data;
    }
  });

  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setResources', resources);
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('filterResources');
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('toggleLoadingResources', false);

  // @TODO Handle errors
}, function (err) {
  console.log(err);
});

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lockr__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lockr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lockr__);



__webpack_require__(93);
var db = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
var unsubscribe = void 0;

__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().onAuthStateChanged(function (user) {
  // @TODO Add a logout message
  if (user) {
    unsubscribe = db.collection('checklist').where('user', '==', user.uid).onSnapshot(function (snap) {
      var data = null;
      snap.docChanges.forEach(function (change) {
        data = change.doc.data();
      });
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setChecklist', data);
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('filterResources');
    });
  } else {
    if (typeof unsubscribe === 'function') {
      var intakeData = __WEBPACK_IMPORTED_MODULE_2_lockr___default.a.get('intakeData');

      unsubscribe();
      unsubscribe = null;

      if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.user.uid && intakeData) {
        __WEBPACK_IMPORTED_MODULE_2_lockr___default.a.set('intakeData', intakeData);
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setChecklist', { data: intakeData });
      }
    }
  }
});

/***/ }),

/***/ 600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventBus_vue__ = __webpack_require__(601);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventBus_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lockr__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lockr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lockr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_firebase__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_init__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_init___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__store_init__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_filters__ = __webpack_require__(575);








// Setup available categories
var hideAllCategoriesConfig = {};
var showAllCategoriesConfig = {};
__webpack_require__(140).forEach(function (category) {
  hideAllCategoriesConfig[category.value] = true;
  showAllCategoriesConfig[category.value] = false;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    isMainSidebarActive: false,
    isLoginModalActive: false,
    isProfileModalActive: false,
    isResourceModalActive: false,
    isAboutModalActive: false,
    isLoadingResources: true,
    isIntakeModalActive: false,
    isIntakeConfigModalActive: false,

    user: {},
    resources: __WEBPACK_IMPORTED_MODULE_3_lockr___default.a.get('resources') || {},
    visibleResources: {},
    hiddenResources: {},
    checklist: __WEBPACK_IMPORTED_MODULE_3_lockr___default.a.get('checklist'),

    // Stores the intake form's temporary config data as populated by @/components/checklist/Intake
    intakeConfig: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_5__store_init___default.a.intakeConfig),

    // Stores the users intake data
    intakeData: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_3_lockr___default.a.get('intakeData') || __WEBPACK_IMPORTED_MODULE_5__store_init___default.a.intakeConfig),

    // {Null|Object} The mode to open the resource modal in. {NULL} for add or {OBJECT = resource} for edit
    editingResource: null,
    activeCategories: showAllCategoriesConfig,
    hasActiveMarkers: false,

    view: 'main'
  },

  mutations: {
    // Modals and Sidebars
    toggleMainSidebar: function toggleMainSidebar(state) {
      return state.isMainSidebarActive = !state.isMainSidebarActive;
    },
    toggleLoginModal: function toggleLoginModal(state) {
      return state.isLoginModalActive = !state.isLoginModalActive;
    },
    toggleProfileModal: function toggleProfileModal(state) {
      return state.isProfileModalActive = !state.isProfileModalActive;
    },
    toggleResourceModal: function toggleResourceModal(state, resource) {
      state.editingResource = resource;
      state.isResourceModalActive = !state.isResourceModalActive;
    },

    toggleAboutModal: function toggleAboutModal(state) {
      return state.isAboutModalActive = !state.isAboutModalActive;
    },
    toggleIntakeModal: function toggleIntakeModal(state) {
      return state.isIntakeModalActive = !state.isIntakeModalActive;
    },
    toggleIntakeConfigModal: function toggleIntakeConfigModal(state) {
      return state.isIntakeConfigModalActive = !state.isIntakeConfigModalActive;
    },
    closeModals: function closeModals(state) {
      state.isMainSidebarActive = false;
      state.isLoginModalActive = false;
      state.isProfileModalActive = false;
      state.isAboutModalActive = false;
      state.isIntakeModalActive = false;
    },


    // User
    setUser: function setUser(state, user) {
      return state.user = user;
    },
    // @TODO Toast success
    // @TODO Catche error
    deleteUser: function deleteUser(state) {
      state.user.delete();
      state.user = {};
    },
    logout: function logout(state) {
      state.user = {};
      state.checklist = null;
      __WEBPACK_IMPORTED_MODULE_4__service_firebase__["a" /* default */].auth().signOut();
    },


    // Categories
    toggleCategories: function toggleCategories(state, categories) {
      categories.forEach(function (category) {
        var isActive = !!state.activeCategories[category];
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.activeCategories, category, !isActive);
      });
    },
    showAllCategories: function showAllCategories(state) {
      state.activeCategories = showAllCategoriesConfig;
    },
    hideAllCategories: function hideAllCategories(state) {
      state.activeCategories = hideAllCategoriesConfig;
    },


    // Resources
    setResources: function setResources(state, data) {
      state.resources = data;
    },

    toggleLoadingResources: function toggleLoadingResources(state, isLoading) {
      return state.isLoadingResources = isLoading;
    },
    filterResources: function filterResources(state) {
      if (!state.resources) return;
      var filtered = {};

      if (state.view === 'checklist' && state.checklist) {
        filtered = __WEBPACK_IMPORTED_MODULE_6__store_filters__["a" /* default */].byChecklist(state.resources, state.checklist);
      } else {
        filtered = __WEBPACK_IMPORTED_MODULE_6__store_filters__["a" /* default */].byCategory(state.resources, state.activeCategories);
      }

      state.visibleResources = filtered.visible;
      state.hiddenResources = filtered.hidden;
      state.hasActiveMarkers = filtered.hasActiveMarkers;

      __WEBPACK_IMPORTED_MODULE_3_lockr___default.a.set('resources', filtered.visible);
    },


    // Checklist
    setChecklist: function setChecklist(state, data) {
      state.checklist = data;
      __WEBPACK_IMPORTED_MODULE_3_lockr___default.a.set('checklist', data);
    },

    viewChecklist: function viewChecklist(state) {
      return state.view = 'checklist';
    },
    viewMain: function viewMain(state) {
      return state.view = 'main';
    },

    // Intake
    clearIntakeConfig: function clearIntakeConfig(state) {
      return state.intakeConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_5__store_init___default.a.intakeConfig);
    },
    setIntakeConfig: function setIntakeConfig(state, data) {
      return state.intakeConfig = data || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_5__store_init___default.a.intakeConfig);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(599);

/***/ })

},[252]);


// WEBPACK FOOTER //
// static/js/app.75e1198c4aac9db226f7.js